import { render, staticRenderFns } from "./PodcastPlayer.vue?vue&type=template&id=36ab49a1"
import script from "./PodcastPlayer.vue?vue&type=script&lang=js"
export * from "./PodcastPlayer.vue?vue&type=script&lang=js"
import style0 from "./PodcastPlayer.vue?vue&type=style&index=0&id=36ab49a1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports